import { createAppSlice } from '@exp/redux/createAppSlice';

import {
  getPubProductPreview,
  getPubRecommendationsForProduct,
  getTopProducts,
} from '../js/common/api';

const initialState = {
  topProducts: [],
};

const topProductsReducer = createAppSlice({
  name: 'topProducts',
  initialState,
  reducers: (create) => ({
    fetchTopProducts: create.asyncThunk(
      () => getTopProducts(),
      {
        fulfilled: (state, action) => {
          state.topProducts = action.payload.data;
        },
      },
    ),

    fetchProductDetails: create.asyncThunk(
      ({ orgId, productCode }) => getPubProductPreview(orgId, productCode),
      {
        pending: (state, action) => {
          const { orgId, productCode } = action.meta.arg;
          state.topProducts = state.topProducts.map(p => {
            if (p.productCode === productCode && p.organizationId === orgId) {
              return { ...p, fetchPending: true };
            }
            return p;
          });
        },
        fulfilled: (state, action) => {
          const details = action.payload.data;
          state.topProducts = state.topProducts.map(p => {
            if (p.productCode === details.productCode &&
              p.organizationId === details.organization?.id) {
              return { ...p, details, fetchPending: false };
            }
            return p;
          });
        },
      },
    ),

    fetchRecommendations: create.asyncThunk(
      ({ orgId, productCode }) => getPubRecommendationsForProduct(orgId, productCode),
      {
        fulfilled: (state, action) => {
          const recommendations = action.payload.data.results || [];
          const { orgId, productCode } = action.meta.arg;
          state.topProducts = state.topProducts.map(p => {
            if (p.productCode === productCode && p.organizationId === orgId) {
              return { ...p, recommendations, fetchPending: false };
            }
            return p;
          });
        },
      },
    ),
  }),
});

export const {
  fetchTopProducts,
  fetchProductDetails,
  fetchRecommendations,
} = topProductsReducer.actions;

export default topProductsReducer.reducer;
